<template>
  <v-application v-if="access.customers">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="customer"
          v-model="currentPage"
          v-bind:num-pages="num_pages"
          upload="/clients/import"
          v-bind:download="download()"
          v-bind:headers="headers"
          v-bind:data="data"
          v-bind:row="typing"
          v-bind:save="save"
          v-bind:remove="remove"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:add_button_name="'add_customer'"
          v-bind:saveDisabled="saveDisabled"
          Customers
          to="/customer"
          showSearch
          v-bind:search_text="search_text"
          v-bind:getData="update"
          v-bind:searchActivate="
            (state) => {
              search_text = state;
            }
          "
          v-bind:setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #search>
            <v-btn icon @click="downloadCustomExcel">
              <v-icon> mdi-download </v-icon>
            </v-btn>
            <v-dialog v-model="proccesDialog" max-width="400px">
              <v-card>
                <v-list-item-action style="width: 338px; padding-left: 40px">
                  <v-progress-linear
                    :color="
                      excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'
                    "
                    background-color="white"
                    height="10"
                    style="border: 1px solid rgba(0, 0, 0, 0.26)"
                    v-bind:value="excel_dowload_proccess"
                    striped
                  />
                  <v-list-item-action-text
                    >{{ $t("download") }}
                    {{ excel_dowload_proccess.toFixed() + " %" }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-card>
            </v-dialog>
          </template>
          <v-card-text>
            <v-text-field
              v-model="customer.first_name"
              ref="first_name"
              :rules="[fieldRules.required]"
              :label="$t('first_name')"
            />
            <v-text-field
              v-model="customer.last_name"
              :label="$t('last_name')"
            />
            <v-text-field
              v-model="customer.email"
              :label="$t('email')"
              prepend-icon="mdi-email"
            />

            <v-text-field
              v-model="customer.phone_number"
              v-mask="mask"
              prefix="+998"
              :label="$t('phone_number')"
              prepend-icon="mdi-phone"
              ref="phone_number"
              :rules="[fieldRules.required]"
            />
            <v-text-field
              v-model="customer.note"
              :label="$t('note')"
              prepend-icon="mdi-note-text"
              counter="255"
            />

            <v-layout v-if="customer && customer.debt" row px-2>
              <v-flex md4 px-2>
                <vuetify-money
                  :value="customer.debt"
                  :label="$t('debt')"
                  :options="moneyOptions"
                  readonly
                />
              </v-flex>
              <v-flex md4 px-2>
                <vuetify-money
                  :value="customer.debt - paid"
                  :label="$t('rest_debt')"
                  :options="moneyOptions"
                  readonly
                />
              </v-flex>
              <v-flex md4 px-2>
                <vuetify-money
                  v-model="paid"
                  :label="$t('paid')"
                  :options="moneyOptions"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import fileSaver from "file-saver";
import xlsx from "xlsx";
export default {
  name: "Customers",
  data: () => ({
    mask: "(##) ###-##-##",
    customer_edit_index: -1,
    page: 1,
    num_pages: 0,
    data_loading: false,
    total: 0,
    customer: {},
    paid: 0,
    headers: [
      { text: "Customer", value: "customer", align: "left", available: true },
      { text: "Contacts", value: "phone_number" , available: true},
      { text: "First visit", value: "first_visit", available: true },
      { text: "Last visit", value: "last_visit", available: true },
      { text: "Total visits", value: "visit_counter", available: true },
      { text: "Total spent", value: "total_sale" , available: true},
      { text: "Points balance", value: "point_balance", align: "right" , available: true},
      { text: "Club card", value: "is_minimum_price", align: "right", available: true },
    ],
    data: [],
    search_text: false,
    search: "",
    proccesDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
  }),
  methods: {
    async downloadCustomExcel() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      this.loading = true;
      const limit = 500;
      let all_data = [];
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const response = this.$communicator.then(
          this,
          await this.$communicator("customers", {
            arguments: [limit, page],
            params: {
              search: this.search,
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...response?.data);
      }
      this.proccesDialog = false;
      this.loading = true;
      const result = await all_data.map((cus) => ({
        Customer: cus.first_name + " " + cus.last_name,
        Contacts: cus.phone_number,
        First_visit: new Date(cus.first_visit).toLocaleString(),
        Last_visit: new Date(cus.last_visit).toLocaleString(),
        Total_visit: cus.visit_counter,
        Total_spent: cus.total_sale
          ? (Math.round(cus.total_sale * 100) / 100).toLocaleString()
          : cus.total_sale,
        Debt: cus.debt
          ? (Math.round(cus.debt * 100) / 100).toLocaleString()
          : cus.debt,
        Points_balance: cus.point_balance
          ? (Math.round(cus.point_balance * 100) / 100).toLocaleString()
          : cus.point_balance,
        Club_card: cus.is_minimum_price?"true":"false",
      }));
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "Customers.xlsx");
    },
    changePagination(page) {
      // this.page = page;
      this.$store.commit("customers/updatePage", page);
      this.update(this.params);
    },
    download() {
      return "clients/export/" + this.$store.state.token + "/customers.csv";
    },
    async save() {
      var params = this.$copy(this.customer);
      params.phone_number = this.$communicator.clear_phone_number(
        params.phone_number
      );
      if (this.customer_edit_index === -1) {
        this.$communicator.then(
          this,
          await this.$communicator("create_customer", {
            params,
          })
        );
        this.$toast.success("Success", { timeout: 2000 });
        this.update();
      } else {
        this.$communicator.then(
          this,
          await this.$communicator("update_customer", {
            arguments: [this.customer_edit_index],
            params: {
              first_name: params.first_name,
              last_name: params.last_name,
              note: params.note,
              phone_number: params.phone_number,
              email: params.email,
            },
          })
        );
        this.customer_edit_index = -1;
        this.update();
      }
    },
    typing(item) {
      if (item == null) {
        this.customer_edit_index = -1;
        this.customer = {
          phone_number: null,
        };
      } else {
        this.customer_edit_index = item["_id"];
        this.customer = this.$copy(item);
        this.customer.phone_number = this.$communicator.make_phone_number(
          this.customer.phone_number
        );
        delete this.customer["_id"];
      }
    },
    async update() {
      this.data_loading = true;
      const response = this.$communicator.then(
        this,
        await this.$communicator("customers", {
          arguments: [10, this.$store.state.customers.page],
          params: {
            search: this.search,
          },
        })
      );
      this.max_total = response?.total;
      for (let i = 0; i < response.data.length; i++) {
        response.data[i].first_visit = new Date(
          response.data[i].first_visit
        ).toLocaleString();
        response.data[i].last_visit = new Date(
          response.data[i].last_visit
        ).toLocaleString();
        response.data[i].total_sale = response.data[i].total_sale
          ? (
              Math.round(response.data[i].total_sale * 100) / 100
            ).toLocaleString()
          : response.data[i].total_sale;
        response.data[i].point_balance = response.data[i].point_balance
          ? (
              Math.round(response.data[i].point_balance * 100) / 100
            ).toLocaleString()
          : response.data[i].point_balance;
        response.data[i].debt = response.data[i].debt
          ? (Math.round(response.data[i].debt * 100) / 100).toLocaleString()
          : response.data[i].debt;
      }
      this.data = response.data;
      this.num_pages = Math.ceil(response.total / 10);
      for (const index in this.data) {
        this.data[index]["customer"] =
          this.data[index].first_name +
          " " +
          (this.data[index].last_name ? this.data[index].last_name : "");
      }
      this.customer = {};
      this.data_loading = false;
    },
    async remove(items) {
      var indices = [];
      for (const index in items) {
        indices.push(items[index]._id);
      }
      await this.$communicator("delete_customers", {
        params: {
          indexes: indices,
        },
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.update();
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("customer"), value: "customer", align: "left", available: true },
      { text: this.$t("contacts"), value: "phone_number" , available: true},
      { text: this.$t("first_visit"), value: "first_visit", width: 200, available: true },
      { text: this.$t("last_visit"), value: "last_visit", width: 200 , available: true},
      { text: this.$t("total_visits"), value: "visit_counter", available: true },
      { text: this.$t("total_spent"), value: "total_sale" , available: true},
      {
        text: this.$t("debt"),
        value: "debt",
        align: "right",
      },
      {
        text: this.$t("points_balance"),
        value: "point_balance",
        align: "right",
      },
      {
        text: this.$t("club_card"),
        value: "is_minimum_price",
        align: "right",
      },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.update();
  },
  computed: {
    form() {
      return {
        first_name: this.customer.first_name,
        phone_number: this.customer.phone_number,
      };
    },
    currentPage: {
      get() {
        return this.$store.state.customers.page;
      },
      set(val) {
        this.$store.commit("customers/up  datePage", val);
      },
    },
    saveDisabled() {
      let formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
    this.features = this.$store.state.feature;
  },
};
</script>
